const NATIVE_CALL_STATUS = {
    ERROR: -2,
    NOT_AVAILABLE: -1,
    SUCCESS: 1,
    FALLBACK: 2,
};

export default NATIVE_CALL_STATUS;
